import { ReactElement } from 'react';
import { MenuSelectorItem } from './MenuSelectorItem';
import styles from './MenuSelector.module.scss';

type MenuWeek = {
  deliveryDate: string;
  isSelectedMenu: boolean;
  menuId: number;
  cartId: number;
  isSkipped: boolean;
};

type Props = {
  menuWeeks: MenuWeek[];
  currentMenuDate?: string;
  handleSelectMenu: (menuId: number, cartId: number) => void;
  onClose: () => void;
};

export function MenuSelector({
  menuWeeks,
  currentMenuDate,
  handleSelectMenu,
  onClose,
}: Props): ReactElement {
  return (
    <div className={styles.menu_container}>
      <div>
        <div className={styles.text_header}>
          Select Upcoming Menu
        </div>
        {menuWeeks.map((menuWeek) => (
          <MenuSelectorItem
            key={menuWeek.menuId}
            deliveryDate={menuWeek.deliveryDate}
            isSelectedMenu={menuWeek.isSelectedMenu}
            menuId={menuWeek.menuId}
            cartId={menuWeek.cartId}
            isSkipped={menuWeek.isSkipped}
            handleSelectMenu={handleSelectMenu}
            currentMenuDate={currentMenuDate}
            onClose={onClose}
          />
        ))}
      </div>
    </div>
  );
}
